import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';import PropTypes from 'prop-types';
import { softwareProducts } from '../../../../../modules/customer/profile';
import SimpleTable from '../../../../components/SimpleTable';

const columns = [
    { title: 'Navn', dataIndex: 'name', key: 'name', width: 200},
    { title: 'Type', dataIndex: 'type', key: 'type', width: 190},
    { title: 'Contract Start', dataIndex: 'contractStartDate', key: 'contractStartDate', width: 200 },
    { title: 'Contract End', dataIndex: 'contractEndDate', key: 'contractEndDate', width: 200 },
    { title: 'Kontrakt periode', dataIndex: 'contractPeriod', key: 'contractPeriod', width: 200},
    { title: 'Status', dataIndex: 'status', key: 'status', width: 200},
    ];

const Products = ({softwareProducts}) => (
        <SimpleTable
            columns={columns} 
            data={softwareProducts.productsList}
            isLoading={softwareProducts.isLoading}
         />
);

const mapStateToProps = createStructuredSelector({
    softwareProducts: softwareProducts.selectors.getSoftwareProducts
});

export default connect(mapStateToProps)(Products);
